import { Avatar, Box, Button, Divider, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ArrowBackBlue, Download2 } from 'Images';
import { BGCircles } from './BGCircles';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { getDisabilityConfirmationPdf } from 'API/disabilityConfirmation';
import { downloadFile } from 'Utils';
import { exportToPdf } from 'API';
import { useLoader } from 'Hooks/useLoader';

interface IDownloadAndInfoButtons {
  attachmentId?: number;
  disabilityName?: string;
  moreInfoLink: string;
}

export const DownloadAndInfoButtons = ({
  attachmentId,
  disabilityName,
  moreInfoLink,
}: IDownloadAndInfoButtons) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.DisabilityApprovals);
  const { loader, isLoading, setIsLoading } = useLoader('', {}, 20, false);

  const downloadPdfHandler = async () => {
    setIsLoading(true);
    if (attachmentId && disabilityName) {
      const fileSource = await getDisabilityConfirmationPdf(attachmentId);
      if (fileSource) downloadFile(fileSource, 'pdf', disabilityName);
    } else await exportToPdf();
    setIsLoading(false);
  };

  return (
    <Box minWidth={isDesktop ? '270px' : '100%'}>
      <Stack
        position='relative'
        overflow='hidden'
        direction='row'
        justifyContent='center'
        alignItems='center'
        bgcolor='#E7EDFF'
        borderRadius={isDesktop ? '100px' : '0 0 16px 16px'}
        padding='10px 24px'
        gap='10px'
        width={!moreInfoLink ? (isDesktop ? '140px' : '100%') : undefined}
        ml={!moreInfoLink ? (isDesktop ? 'auto' : undefined) : undefined}
      >
        <Stack>
          <Button
            onKeyDown={onEnterOrEscapeKeyDown}
            onClick={downloadPdfHandler}
            sx={{ gap: '6px' }}
          >
            {isLoading ? (
              loader
            ) : (
              <>
                <Avatar
                  alt=''
                  src={Download2}
                  sx={{ width: '20px', height: '20px' }}
                />
                <Typography
                  variant='body5'
                  color='primary.main'
                  whiteSpace='nowrap'
                >
                  {dictionary.download}
                </Typography>
              </>
            )}
          </Button>
        </Stack>
        {moreInfoLink && (
          <>
            <Divider
              orientation='vertical'
              sx={{ height: '24px', borderColor: 'primary.shade_200' }}
            />
            <Stack>
              <Button
                onKeyDown={onEnterOrEscapeKeyDown}
                onClick={() => window.open(moreInfoLink)}
              >
                <Typography
                  variant='body5'
                  color='primary.main'
                  whiteSpace='nowrap'
                >
                  {dictionary.moreInfo}
                </Typography>
                <Avatar
                  alt=''
                  src={ArrowBackBlue}
                  sx={{ width: '16px', height: '16px' }}
                />
              </Button>
            </Stack>
          </>
        )}
        {!isDesktop && <BGCircles />}
      </Stack>
    </Box>
  );
};
